export default __webpack_public_path__ + "static/media/NextProject5.eda8ab99.png";